var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('commission-form',{attrs:{"commissions":_vm.commissions,"action":"create"},on:{"update:commissions":function($event){_vm.commissions=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }